import axios from "axios";
import toast from "react-hot-toast";
import { pipGetAccessToken } from "../../utils/pip";
import { webPaths } from "../../routes/pageRoutes";
import { BASE_URL } from "../../routes/apiURL";

export const API_REQUEST = async (props) => {
  const {
    url,
    method,
    data,
    headers,
    params,
    isErrorToast = true,
    isSuccessToast = true,
  } = props;
  const {token,...other} = pipGetAccessToken();

  const requestOptions = {
    url:
      typeof url === "string" &&
      (url.startsWith("http://") || url.startsWith("https://"))
        ? url
        : BASE_URL + url,
    method,
    headers: {
      Authorization: `Bearer ${token}`,
      ...headers,
    },
    params: method === "GET" ? params : undefined,
    data: method !== "GET" ? data : undefined,
  };
  try {
    const response = await axios(requestOptions);
    if (isSuccessToast) {
      if (method !== "GET" && response?.data?.success === true) {
        toast.success(response?.data?.message);
      } else if (response?.data?.success === false && method !== "GET") {
        toast.error(response?.data?.message);
      }
    }
    return response?.data;
  } catch (error) {
    if (isErrorToast) {
      if (error.response) {
        if (error?.response?.data?.status === 401) {
          toast.error(error?.response?.data?.message);
          localStorage.removeItem("securpoint-web-access-token");
          localStorage.removeItem("secure-point-profile");
          window.location.href =  webPaths?.Login;
          return;
        }
        toast.error(error?.response?.data?.message);
      } else if (error.request) {
        toast.error("No response received from server");
      } else {
        toast.error("Error:", error.message);
      }
    }
    throw error.response;
  }
};
